import React from "react";
import "./About.css";
import Header from "../../components/ChooseSection/Navbar/Header";
import Footer from "../../components/Footer/Footer";




function Mission() {
  return (
    <div className="about-page">
      <Header />
      <header className="height-75">
        <div className="container h-100 d-flex flex-column align-items-center justify-content-center text-light">
          <h1 className="text-center fw-semibold">Mission and Vision</h1>
        </div>
      </header>

      <div className="container my-5">
        <div className="row">
          <div className="col-lg-6 d-flex flex-column text-align-justify justify-content-center mb-4 mb-lg-0">
            <h2 className="mb-4 mb-lg-5">Mission and Vision</h2>
            {/* <p className="mb-4 mb-lg-5" style={{ textAlign: "justify" }}>
              To enable students to develop as intellectually alive, socially responsible citizens ever ready for continuous personal and professional growth.
            </p> */}
            <h4>Vision</h4>

            <p className="mb-4 mb-lg-5" style={{ textAlign: "justify" }}>
              We aspire to be a premier institution of higher education, an inspiring Nodal Center, catering to the diverse needs of student fraternity, providing them State of the Art facilities and a stimulating Teaching Learning Environment, to groom them into socially responsible, excellent human resource.

            </p>

            <h4>Mission</h4>

            <p className="mb-4 mb-lg-5" style={{ textAlign: "justify" }}>

              To enable students to develop as intellectually alive, socially responsible citizens ever ready for continuous personal and professional growth.
            </p>

          </div>
          <div className="col-lg-6 d-flex justify-content-center">
            <img
              src="./img/banner-acm.png"
              className="img-fluid h-100 w-100"
              alt=""
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Mission;
